<template>
  <div id="app" :class="classesApp">
    <navbar v-if="!isErrorPage"/>
    <Menu/>
    <router-view id="content" :class="classesContent"/>

    <Chat v-if="!isAuthPage && !isErrorPage" :pinned-down="isDashboardPage"/>
    <ModalDeleteProfile/>
    <ModalMaterialsUpload/>
    <ModalMaterialsEdit/>
    <ModalMaterialsDelete/>
    <ModalPollStart/>
    <ModalPollQuestion/>
    <ModalFeedbackDetail/>
    <ModalFeedbackAdd/>
    <ModalFeedbackAdded/>
    <Modal id="ask-sent" #default="{ close }">
      <h2>{{ $t('App.requestSentSuccessfully') }}</h2>

      <div class="actions">
        <button class="primary" @click="close">{{ $t('close') }}</button>
      </div>
    </Modal>

    <Toasts/>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
import Navbar from '@/components/Navbar'
import ModalDeleteProfile from '@/components/modals/ModalDeleteProfile'
import ModalAskSchool from '@/components/modals/ModalAskSchool'
import ModalMaterialsUpload from '@/components/modals/ModalMaterialsUpload'
import ModalPollStart from '@/components/modals/ModalPollStart'
import ModalPollQuestion from '@/components/modals/ModalPollQuestion'
import ModalFeedbackDetail from '@/components/modals/ModalFeedbackDetail'
import ModalFeedbackAdd from '@/components/modals/ModalFeedbackAdd'
import Toasts from '@/components/ui/Toasts'

import { mapActions, mapMutations, mapState } from 'vuex'
import Modal from '@/components/modals/Modal'
import Chat from '@/components/chat/Home'
import ModalFeedbackAdded from './components/modals/ModalFeedbackAdded'
import ModalMaterialsEdit from '@/components/modals/ModalMaterialsEdit.vue'
import ModalMaterialsDelete from '@/components/modals/ModalMaterialsDelete.vue'

export default {
  components: {
    ModalMaterialsDelete,
    ModalMaterialsEdit,
    ModalFeedbackAdded,
    Modal,
    ModalMaterialsUpload,
    ModalAskSchool,
    ModalDeleteProfile,
    ModalPollStart,
    ModalPollQuestion,
    ModalFeedbackDetail,
    ModalFeedbackAdd,
    Toasts,
    Navbar,
    Menu,
    Chat,
  },
  data: () => ({
    interval: false,
    eventer: null,
  }),
  computed: {
    isErrorPage() {
      return this.$route.name === 'Error'
    },
    isAuthPage() {
      return this.$route.name === 'Auth'
    },
    classesContent() {
      return this.$route.matched.map(({meta}) => meta.content)
    },
    classesApp() {
      return this.$route.matched.map(({meta}) => meta.app)
    },
    isAuthenticated() {
      const user = this.$auth && this.$auth.user()

      return user ? true : false
    },
    isDashboardPage() {
      return this.$route.name === 'Dashboard'
    },
    ...mapState('users', ['usersReady']),
  },
  methods: {
    updateUsers() {
      this.interval = setTimeout(() => {
        this.getLogsIds()
        if (this.usersReady) {
          this.getUsers()
              .then(() => {
                return this.mfcProcessing()
              })
              .finally()
        }
        this.updateUsers()
      }, 1000 * 60 * 4) //4min
    },
    connectSocket() {
      if (this.isAuthenticated) {
        // vue echo
        const user = this.$auth && this.$auth.user()
        const token = this.$auth && this.$auth.token()
        // const token = localStorage.getItem('auth_token_default')

        this.$echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + token

        if (user && user.id) {
          // console.log('creating socket 6003', token)

          this.$echo
              .join(`groups.${user.id}`)
              .listen('.chat.group.update', (payload) => {
                console.log('echo responce on chat.group.updated', payload)
                this.updateGroup(payload);
              })
              .listen('.chat.group.added', (payload) => {
                console.log('echo responce on chat.group.added', payload)
                this.addGroup(payload);
              })
              .listen('.chat.group.deleted', (payload) => {
                console.log('echo responce on chat.group.droped', payload)
                this.deleteGroup(payload);
              })
        }

        // notification socket
        if (user && user.id) {
          this.$echo.channel(`notifications`)
              .listen('.notification', (e) => {
                console.log('notifications channel responce', e)
              })

          this.$echo.join(`notifications.${user.id}`)
              .listen('.notification', (e) => {
                console.log('notification channel responce', e)
                //const {content, socket, title, type} = e

                this.addNotification(e)
                this.addLogId(e?.id)
                this.$toast({title: 'You have new notification'})
              })
        }

        this.$echo.connector.socket
          .on('connect', (e) => {
            console.log('connect', e);
            this.SOCKET_ONOPEN()
            this.sendSignal({user_id: user.id})
          })
          .on('users', (ids) => {
            console.log('users', ids);
            this.setMembersOnline(ids)
          })
          .on('message', (data) => {
            console.log('on message', data)
          })
      }
    },
    sendSignal(data) {
      //this.$echo.emit('signal', data)
    },
    ...mapMutations('events', ['addLogId']),
    ...mapMutations(['updateTime']),
    ...mapMutations('chat', ['SOCKET_ONOPEN', 'setMembersOnline', 'updateGroup', 'addGroup', 'addGroup']),
    ...mapActions('library', ['mfcProcessing']),
    ...mapActions('users', ['getUsers']),
    ...mapActions('events', ['getLogsIds']),
    ...mapActions('notifications', ['addNotification']),
  },
  created() {
    this.getLogsIds()
    this.updateUsers()
    setInterval(() => {
      this.updateTime()
    }, 1000 * 60)
  },
  mounted() {
    this.connectSocket()
  },
  destroyed() {
    if (this.interval) {
      clearTimeout(this.interval)
    }
  },
  watch: {
    isAuthenticated(v) {
      if (v) {
        this.connectSocket()
      }
    },
    $route(route, old) {
      if (route.path !== old.path) {
        this.sendSignal({page: this.$route.path})
      }
      this.$store.commit('closeMenu')
    },
  },
}
</script>

<style lang="scss">
@import 'style/bootstrap-reboot.min.css';
@import 'style/_fonts.scss';
@import 'style/_elements.scss';
@import 'style/tippy.scss';

body {
  font-family: 'Source Sans Pro', sans-serif;
  background: $bg;
  color: $text;
  font-size: 14px;

  &.modal-open {
    overflow: hidden;
  }

  h1,
  h2 {
    font-family: 'Source Serif Pro', serif;
    font-weight: 700;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Source Serif Pro', serif;
  color: #474747;
}

#app {
  display: flex;
  flex-direction: column;
  align-items: center;

  &.white {
    background: white;
    min-height: 100vh;
  }

  &.info-panel {
    #navbar {
      margin-left: 121px;
      margin-right: 332px;
    }
  }
}

#content {
  $paddingSm: 35px 20px;
  $padding: 35px 40px;
  $paddingPC: 30px 48px;

  background: $white;
  padding: $padding;
  position: relative;
  width: 100%;
  width: calc(100% - 171px);
  max-width: 1190px;

  @include mobileSm {
    padding: $paddingSm;
  }

  @include mobile {
    width: 100%;
  }

  &.transparent {
    background: transparent;
    padding: 0;

    @include mobile {
      padding: 0;
    }
  }

  hr.full {
  }

  @include PC {
    border-radius: 10px;
    margin: 0 58px 0 122px;
    padding: $paddingPC;

    hr.full {
    }
  }

}

#content, #navbar {
  &.dashboard {
    padding: 0;
  }

  @include PC {
    &.dashboard {
      display: flex;
      width: 100%;
      max-width: 100%;
      padding-left: 77px;
      margin-left: 0;
      margin-right: 0;
    }

    > .dashboard, &.dashboard > .navbar-wrapper {
      padding-left: 45px;
      padding-right: 32px;
      max-width: 1190px;
      margin: 0 auto;
      margin-bottom: 62px;
    }
  }
  @include mobile {
    &.dashboard {
      display: flex;
      flex-direction: column-reverse;
    }
  }
}

@include PC {
  * {
    scrollbar-width: auto;
    scrollbar-color: #f0f3f8 #ffffff;
  }

  *::-webkit-scrollbar {
    height: 15px;
    width: 15px;
  }

  *::-webkit-scrollbar-track {
    background: #ffffff;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #f0f3f8;
    border-radius: 10px;
    border: 5px solid #ffffff;

    &:hover {
      background-color: #e6ebf3;
    }
  }
}
</style>
